import { render } from "./limited_textarea.vue?vue&type=template&id=9d5ab40a"
import script from "./limited_textarea.vue?vue&type=script&lang=js"
export * from "./limited_textarea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__